module.exports = __webpack_public_path__ + "static/media/send.58c67391.svg";